<template>
<div class="vertical-align-wrap">
  <div class="vertical-align-middle maintenance">

  <div class="text-center">
    <article>
      <h1>Thank You!</h1>
      <div>
        <p>LETS REPORT ANOTHER CONFORMANCE (TERIMA KASIH! AYO LAPORKAN LEBIH BANYAK KETIDAK SESUAIN/NON CONFORMANCE)</p>
        <p>&mdash; Unilever</p>
      </div>
    </article>
    <div class="margin-top-30">
      <router-link to="" class="btn btn-info" @click.native="goToHome"><i class="fa fa-home"></i> Submit Another Observation </router-link>
    </div>
  </div>
  </div>
  </div>
</template>

<script>
export default {
  methods: {
    goToHome() {
      this.$router.push({ name: 'observation' })
    }
  }
}
</script>